import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723d0030"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RegistrationHeader" }
const _hoisted_2 = { class: "Title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "TitleHighlight" }, " free account ", -1 /* HOISTED */))
const _hoisted_4 = { class: "SubText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createTextVNode(" Create a "),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.titleCopy), 1 /* TEXT */)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subText), 1 /* TEXT */)
  ]))
}